import { render, staticRenderFns } from "./JsonEdit.vue?vue&type=template&id=bcb5dc7a&"
import script from "./JsonEdit.vue?vue&type=script&lang=js&"
export * from "./JsonEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports